export const Marquee = ({ text, className = "" }) => {
  return (
    <div className={`overflow-hidden ${className}`} data-testid="marquee">
      <div className="marquee-track animate-marquee">
        {Array.from({ length: 6 }).map((_, i) => (
          <span key={i} className="font-heading font-black uppercase inline-block px-6">
            {text}
            <span className="text-gavito-green/50 px-6" aria-hidden="true">•</span>
          </span>
        ))}
      </div>
    </div>
  );
};
